export default __webpack_public_path__ + "static/media/Imagen_logo_cpba.a77e5487.jpg";